import Navbar from '../../components/feature/Navbar';
import SeoHead from '../../components/feature/SeoHead';
import CommunityHero from './components/CommunityHero';
import SchoolRevitalization from './components/SchoolRevitalization';
import EmploymentOpportunities from './components/EmploymentOpportunities';
import EconomicImpact from './components/EconomicImpact';
import YouthAttraction from './components/YouthAttraction';
import SustainableIndustry from './components/SustainableIndustry';
import Footer from '../../components/feature/Footer';

const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) ?? '';

const communityJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '地域貢献 | 株式会社C.GREEN | 廃校活用・地域雇用・若者定着',
  url: `${siteUrl}/community`,
  description:
    '廃校活用による地域貢献の取り組みをご紹介。地域雇用創出・若者定着・経済活性化・持続可能な産業形成など、C.GREENが目指す地域社会の姿を解説します。',
  inLanguage: 'ja',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: '地域貢献', item: `${siteUrl}/community` },
    ],
  },
};

export default function CommunityPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="地域貢献 | 株式会社C.GREEN | 廃校活用・地域雇用・若者定着"
        description="廃校活用による地域貢献の取り組みをご紹介。地域雇用創出・若者定着・経済活性化・持続可能な産業形成など、C.GREENが目指す地域社会の姿を解説します。"
        keywords="地域貢献,廃校活用,地域雇用創出,若者定着,地域経済活性化,持続可能産業,C.GREEN地域"
        canonicalPath="/community"
        jsonLd={communityJsonLd}
      />
      <Navbar />
      <CommunityHero />
      <SchoolRevitalization />
      <EmploymentOpportunities />
      <EconomicImpact />
      <YouthAttraction />
      <SustainableIndustry />
      <Footer />
    </div>
  );
}
